import ProcessState from './ProcessState';

export default class FirmwareRolloutSampleEventDTO {

    public processState: ProcessState;
    public erroredOut: boolean;
    public errorMessage?: string;
    public reportedFirmwareVersion?: string;
    public occurredAt: string;
    public receivedAt: string;

    constructor(data: { [key: string]: any }) {
        this.processState = data['processState'];
        this.erroredOut = data['erroredOut'];
        this.errorMessage = data['errorMessage'];
        this.reportedFirmwareVersion = data['reportedFirmwareVersion'];
        this.occurredAt = data['occurredAt'];
        this.receivedAt = data['receivedAt'];
    }
}
